import logo1 from "../../assets/images/partners/kwpwroclaw.png";
import logo2 from "../../assets/images/partners/mgi.png";
import logo3 from "../../assets/images/partners/my-medikal.png";
import logo4 from "../../assets/images/partners/Poczta-polska_logo.png";
import logo5 from "../../assets/images/partners/policja.png";
import logo6 from "../../assets/images/partners/szpital.png";
import logo7 from "../../assets/images/partners/ctn-moszna.png";
import logo8 from '../../assets/images/partners/gamma-medica.png';
import logo9 from '../../assets/images/partners/myslowickie-centrum-zdrowia.png';
import logo10 from '../../assets/images/partners/logo_pszczyna.jpg';
import logo11 from '../../assets/images/partners/zol-kielce.png';

import ref1 from '../../assets/files/ref-kwp-wroclaw.pdf';
import ref2 from '../../assets/files/declaration-mgimed.pdf';
import ref3 from '../../assets/files/declaration-mymedikal.pdf';
import ref4 from '../../assets/files/ref-poczta-polska.pdf';
import ref5 from '../../assets/files/ref-kwp-krakow.pdf';
import ref6 from '../../assets/files/ref-szpital-bielskobiala.pdf';
import ref7 from '../../assets/files/ref-ctn-moszna.pdf';
import ref8 from '../../assets/files/ref-gamma-medica.pdf';
import ref9 from '../../assets/files/ref-myslowickie-centrum-zdrowia.pdf';
import ref10 from '../../assets/files/ref-perla-pszczyna.pdf';
import ref11 from '../../assets/files/ref-zol-kielce.pdf';

const partnersLogos = [
  {
    logo: logo1,
    alt: "Komenda Wojewódzka Policji w Wrocławiu",
    link: ref1,
  }, {
    logo: logo2,
    alt: "MGI Medical",
    link: ref2,
  }, {
    logo: logo3,
    alt: "My Medikal",
    link: ref3,
  }, {
    logo: logo4,
    alt: "Poczta Polska",
    link: ref4,
  }, {
    logo: logo5,
    alt: "Komenda Główna Policji w Krakowie",
    link: ref5,
  }, {
    logo: logo6,
    alt: "Szpital Pediatryczny w Bielsku Białej",
    link: ref6,
  }, {
    logo: logo7,
    alt: "Centrum Terapii Nerwic w Mosznej",
    link: ref7,
  }, {
    logo: logo8,
    alt: 'Gamma Medica',
    link: ref8,
  }, {
    logo: logo9,
    alt: 'Mysłowickie Centrum Zdrowia',
    link: ref9,
  }, {
    logo: logo10,
    alt: 'Perła Księżnej Daisy - Pszczyna',
    link: ref10,
  }, {
    logo: logo11,
    alt: 'Zakład Opiekuńczo Leczniczy - Kielce',
    link: ref11,
  }
];

export { partnersLogos };